import { BasicRequest } from "./basicRequest";

export class DeleteConsolidationDefinitionRequest extends BasicRequest{
    public consolidationDefinitionId! : number;
    public physicalDelete : boolean = false;
}